/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RenameInstructionDto
 */
export interface RenameInstructionDto {
    /**
     * New custom name for the instruction
     * @type {string}
     * @memberof RenameInstructionDto
     */
    customName: string;
}

/**
 * Check if a given object implements the RenameInstructionDto interface.
 */
export function instanceOfRenameInstructionDto(value: object): value is RenameInstructionDto {
    if (!('customName' in value) || value['customName'] === undefined) return false;
    return true;
}

export function RenameInstructionDtoFromJSON(json: any): RenameInstructionDto {
    return RenameInstructionDtoFromJSONTyped(json, false);
}

export function RenameInstructionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RenameInstructionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'customName': json['customName'],
    };
}

export function RenameInstructionDtoToJSON(json: any): RenameInstructionDto {
    return RenameInstructionDtoToJSONTyped(json, false);
}

export function RenameInstructionDtoToJSONTyped(value?: RenameInstructionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'customName': value['customName'],
    };
}

